import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { IMfaData } from '../store/createAccountantOnboarding';

interface IProps {
    customerId: string;
    authorizedUserId: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
}
export const usePostStartOb = () => useMutation('usePostStartOb', async ({
  customerId, authorizedUserId, firstName, lastName, phoneNumber,
}: IProps) => {
  const { data } = await httpService.post(
    `/api/v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/start`,
    {
      phoneNumber,
      firstName,
      lastName,
    },
  );
  return data as IMfaData;
});
